import { retailers, setBookInfo } from "./view-models/bookInfo.js";
import { setupAppSignals } from "./view-models/app-signals.js";
import "./view-models/tracking.js";
import "./views/cassis-reader.js";
import { VERSION } from "./version.js";

export { VERSION };

/**
 * @import {AppConfig} from "../src/app.ts"
 */

/**
 * Starts the reader. `config` is the reader options (INTEGRATION.md lists
 * every key) and `pdfConfig` is `{ url, workerPath, cmaps }`.
 *
 * @param {AppConfig} config
 */
export async function start(config, pdfConfig) {
  // Lets support and tests see which viewer build is on a page.
  document.documentElement.dataset.cassisPdfVersion = VERSION;
  // If guide is enabled use the data attribute to signal to the settings component
  document.documentElement.dataset.cassisShowGuideSection = "false";
  if (config.enableGuide) {
    document.documentElement.dataset.cassisShowGuideSection = "true";
  }
  if (config.enableLocaleSwitcher) {
    document.documentElement.dataset.cassisShowLocaleSection = "true";
  }

  if (config.autoHideToolbar) {
    document.documentElement.dataset.cassisAutoHideToolbar = "true";
  }
  if (config.preventContextMenu) {
    document.documentElement.dataset.cassisPreventContextmenu = String(
      config.preventContextMenu,
    );
  }

  setBookInfo(config.bookInfo);
  // Rails passes retailers: null; selectedRetailer needs an array.
  retailers(config.retailers || []);
  setupAppSignals(config, pdfConfig);

  if (!config.disableAnimation) {
    setTimeout(function () {
      const autoHideEvent = new CustomEvent("cassis:hideToolbar", {
        detail: { timeout: config.autoHideToolbar },
      });
      document.documentElement.dispatchEvent(autoHideEvent);
    }, config.autoHideToolbar || 3500);
  }
}

/**
 * The embedding API (interface contract §3): Rails' initialiser calls
 * startPdfReader(readerOptions, { url, workerPath, cmaps }).
 */
export const startPdfReader = start;
